// Constants
import { FileTypeConstants } from "../../constants/GeneralConstants";

export function saveFile(filename, data) {
  const link = document.createElement("a");
  link.target = "_blank";
  link.download = filename;
  link.href = URL.createObjectURL(
    new Blob([data], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    })
  );
  link.click();
}

export function saveImageFile(filename, data, imageType) {
  const link = document.createElement("a");
  link.target = "_blank";
  link.download = filename;
  link.href = URL.createObjectURL(
    new Blob([data], {
      type: `image/${imageType}`,
    })
  );
  link.click();
}

export function selectFile(isMultiSelect = false, fileExtensions = []) {
  return new Promise((resolve) => {
    function handleFileSelect(e) {
      const file = e.target.files;
      resolve(file);
    }

    const input = document.createElement("input");
    input.type = "file";
    input.multiple = isMultiSelect;
    if (fileExtensions && fileExtensions.length) {
      input.accept = fileExtensions.join(",");
    }
    input.onchange = handleFileSelect;
    input.click();
  });
}

// separate Files By Type
export function separateFilesByType(fileList) {
  const filesArray = Array.from(fileList);

  // Constants
  const { image, video } = FileTypeConstants;

  // image files
  const imageFiles = filesArray.filter(
    (file) => file.type.startsWith("image/") || file.type === image
  );

  // video files
  const videoFiles = filesArray.filter(
    (file) => file.type.startsWith("video/") || file.type === video
  );

  return { imageFiles, videoFiles };
}
